import { render, staticRenderFns } from "./IconSvgKey.vue?vue&type=template&id=a3c6883a&scoped=true&"
import script from "./IconSvgKey.vue?vue&type=script&lang=js&"
export * from "./IconSvgKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c6883a",
  null
  
)

export default component.exports